module.exports = __webpack_public_path__ + "img/31.01e2fa99.png";